import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Description.module.scss'

/**
 * The `Description`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Description = forwardRef((props, forwardedRef) => {
  const { children, className, size, ...rest } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        lineItemStyles.description,
        styles.description,
        styles[`size-${normalizeSizeString(size)}`]
      ]),
    [className, size]
  )

  return (
    <div ref={ref} className={classNameOutput} {...rest}>
      {children}
    </div>
  )
})

// Display name
Description.displayName = 'Description'

/** @type {object} */
Description.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string
}

/** @type {object} */
Description.defaultProps = {
  children: null,
  className: '',
  size: 'standard'
}

// Memoize
export default memo(Description)
